import {config} from 'rxjs';
import {distinctUntilChanged, filter, map} from 'rxjs/operators';
import '@px/helper/pollyfill/Array';
import '@px/helper/pollyfill/EventTarget';
import '@px/helper/pollyfill/Map';

import * as WsData from '@px/ws-data';

const {
  openWS,
  wsStatus$,
  toUiMsg$,
  uiMsg$,
  currencies$,
  contracts$,
  spots$,
  riskLimits$,
  leverages$,
  marginCurrencies$,
  marginPairs$,
  marginRiskLevels$,
  leverageMargins$,
  contractDefaultTakerFeeRateEr$,
  // 订阅
  subscribeAdl,
  subscribeAssets,
  subscribeAudioContract,
  subscribeAudioSpot,
  subscribeBook,
  subscribeContractAccount,
  subscribeDepth,
  subscribeKline,
  subscribeMarketContract,
  subscribeMarketSpot,
  subscribePosition,
  subscribeTrade,
  subscribeSpotWallet,
  subscribeContractActiveOrder,
  subscribeContractConditionalOrder,
  subscribeContractFillOrder,
  subscribeContractHistoryOrder,
  subscribeSpotActiveOrder,
  subscribeSpotConditionalOrder,
  subscribeSpotFillOrder,
  subscribeSpotHistoryOrder,
  subscribeTick,
  subscribeNotificationContractOrder,
  subscribeNotificationContractPosition,
  subscribeNotificationSpotOrder,
  subscribeMarginTrade,
  subscribeTpsl,
  subscriberUsers,
  subscribeIndexPrice,
  subscribeContractBiz,
  subscribeLendingAccount,
  subscribeRas,
  subscribeFiatDepositPush,
  ...WsDataRest
} = WsData;

subscribeAdl();
subscribeAssets();
subscribeAudioContract();
subscribeAudioSpot();
subscribeBook();
subscribeContractAccount();
subscribeDepth();
subscribeKline();
subscribeMarketContract();
subscribeMarketSpot();
subscribeNotificationContractOrder();
subscribeNotificationContractPosition();
subscribeNotificationSpotOrder();
subscribeContractActiveOrder();
subscribeContractConditionalOrder();
subscribeContractFillOrder();
subscribeContractHistoryOrder();
subscribeSpotActiveOrder();
subscribeSpotConditionalOrder();
subscribeSpotFillOrder();
subscribeSpotHistoryOrder();
subscribePosition();
subscribeSpotWallet();
subscribeTick();
subscribeTrade();
subscribeMarginTrade();
subscribeTpsl();
subscriberUsers();
subscribeIndexPrice();
subscribeContractBiz();
subscribeLendingAccount();
subscribeRas();
subscribeFiatDepositPush();

(function dynamicSubscribe() {
  /**
   * 同一方法仅可订阅一次
   */
  const checkValidSubscribe = (function () {
    const subsRecord = {};

    return (method: string) => {
      if (subsRecord[method] > 0) {
        return false;
      }

      subsRecord[method] = (subsRecord[method] || 0) + 1;
      return true;
    };
  })();

  uiMsg$.pipe(filter((uiMsg) => uiMsg.type === 'dynamic-subscribe')).subscribe(({method}) => {
    if (!checkValidSubscribe(method)) {
      return;
    }

    WsDataRest[method]();
  });
})();

config.onUnhandledError = function (error) {
  if (error.type === 'close') {
    console.warn('ws close');
    return;
  }

  console.warn('rxjs error', error);
};

uiMsg$.pipe(filter((o) => o.type === 'foundation-data')).subscribe(({currencies, contracts, spots, riskLimits, leverages, marginCurrencies, marginPairs, marginRiskLevels, leverageMargins}) => {
  currencies$.next(currencies);
  contracts$.next(contracts);
  spots$.next(spots);
  riskLimits$.next(riskLimits);
  leverages$.next(leverages);
  marginCurrencies$.next(marginCurrencies);
  marginPairs$.next(marginPairs);
  marginRiskLevels$.next(marginRiskLevels);
  leverageMargins$.next(leverageMargins);

  toUiMsg$.next({type: 'worker-ready'});
});

uiMsg$
  .pipe(
    filter((o) => o.type === 'ws-url'),
    map((o) => o.url),
    distinctUntilChanged()
  )
  .subscribe(openWS);

wsStatus$.subscribe((status) => {
  console.log('WS Status:', status);
  toUiMsg$.next({type: 'ws-status', data: {status}});
});

uiMsg$
  .pipe(
    filter((o) => o.type === 'contract-default-taker-fee-rate'),
    map((o) => o.contractDefaultTakerFeeRateEr),
    filter((takerFeeRateEr) => !!takerFeeRateEr || takerFeeRateEr === 0)
  )
  .subscribe((o) => contractDefaultTakerFeeRateEr$.next(o));
